import React from "react";
import { Switch, useRouteMatch } from "react-router-dom";
import PrivateRoute from "../../../../Routes/PrivateRoutes";
import TipoContatoProvider from "./TipoContatoContext";
import PesquisarTipoContato from "./Events/PesquisarTipoContato";
import FormularioTipoContato from "./Events/FormularioTipoContato";

const Index = () => {
  let match = useRouteMatch();
  return (
    <TipoContatoProvider>
      <div className="container-fluid pl-3 pt-3 pb-3">
        <Switch>
          <PrivateRoute
            exact
            path={`${match.url}`}
            component={PesquisarTipoContato}
          />
          <PrivateRoute
            path={`${match.url}/:id`}
            component={FormularioTipoContato}
          />
        </Switch>
      </div>
    </TipoContatoProvider>
  );
};

export default Index;
